import { ISchema, PaywallComponentProps } from '../../@types'

// Variant C — highlight discount + timer, no CTA button.
export default (schema: ISchema): ISchema => ({
	...schema,
	overrides: {
		...schema.overrides,
		PaywallCountdownQuickAccess: ({ $t, ctx }): PaywallComponentProps.CountdownQuickAccess => ({
			theme: 'discount-timer',
			text: $t('pages.program.header_banner.discount_reserved', { discount_percent: ctx.discountPercent }),
			buttonEvent: 'scrollToPlanPicker',
		}),
	},
})
